
$(function () {
  $('[data-toggle="tooltip"]').tooltip()
})

import './js/fixed-elements.js';


function show_loading(){ return true; }
function hide_loading(){ return true; }

window.show_loading = show_loading;
window.hide_loading = hide_loading;